import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { NavigationManagerContext } from './hook.manager.js';

function Link(props) {
  const { enhanceLink } = useContext(NavigationManagerContext);
  return (enhanceLink == null ? void 0 : enhanceLink(props, props.ref)) ?? /* @__PURE__ */ jsx("a", { ...props, ref: props.ref, children: props.children });
}

export { Link };
//# sourceMappingURL=comp.link.js.map
